<template>
  <div class="submenu">
    <div class="container">
      <div class="cn-block">
        <span class="line"></span>
        <span class="text">{{titleName}}</span>
        <div class="grid-parent-block">
          <van-grid :column-num="3" square>
            <van-grid-item v-for="(sub, index) in items" :key="sub.id" :text="sub.name" @click="goPage(sub.visitUrl, index)">
              <van-icon v-if="sub.iconType == 1" class="defont" slot="icon" :color="sub.iconColor" size="28" :name="sub.iconUrl"></van-icon>
              <van-icon v-if="sub.iconType == 2" class="iconfont" class-prefix="icon" slot="icon" :color="sub.iconColor" :name="sub.iconUrl"></van-icon>
              <van-image v-if="sub.iconType == 3" class="icon-img" slot="icon" :src="filePath + sub.iconUrl" :data-index="index" />
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <app-footer v-if="footer_show" :token="token"></app-footer>
  </div>
</template>
<script>
import Vue from 'vue'
import { Notify, Grid, GridItem, Icon, Image as VanImage } from 'vant'
import { fetchGet } from '../../utils/axiosfunc.js'
import Footer from '../../components/Footer'

Vue.use(Notify)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(VanImage)
Vue.use(Icon)

export default {
  data () {
    return {
      token: this.$cookies.get('token'),
      items: [],
      footer_show: true,
      titleName: '业务办理'
    }
  },
  components: {
    'app-footer': Footer
  },
  created () {
    // 隐藏父路由底部logo
    this.$parent.footer(false)

    // 获取路由参数
    const query = this.$route.query
    const parentId = query.parentId

    const reqRrl = '/client/api/secondMenu.do'
    const params = {
      token: this.$cookies.get('token'),
      parentId: parentId
    }
    // 菜单
    fetchGet('/mobilebus' + reqRrl, params).then(response => {
      const data = JSON.parse(response.request.response)
      console.log(data)
      if (data.code === 200) {
        this.titleName = data.data.titleName
        this.$parent.changeBusstypeText(data.data.titleName, '尊敬的用户\n请选择您所需办理的业务')
        this.items = data.data.subMenuForms
      }
    })
  },
  mounted () {
  },
  methods: {
    goPage (url) {
      this.$router.push({
        path: url,
        query: {
          token: this.$cookies.get('token'),
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .submenu {
    background-color: #FFF;
  }
  .submenu .container {
    margin: 0 15px;
    padding-top: 15px;
    padding-bottom: 90px;
  }
  .cn-block .line {
    width: 4px;
    height: 16px;
    background-color: #008ACB;
    display: inline-block;
    margin-right: 10px;
  }
  .cn-block .text {
    font-size: 16px;
    color: #646566;
  }
  .van-image {
    vertical-align: middle;
  }
  .grid-parent-block .van-image, .iconfont {
    width: 40px;
    height: 40px;
    padding: 10px;
    vertical-align: middle;
    border-radius: 50%;
    box-shadow: 2px 2px 10px rgb(167 196 250 / 30%);
  }
  /deep/ .van-grid-item__text {
    margin-top: 8px;
    font-size: 13px;
  }
  /deep/ .van-grid-item__content::after {
    border-width: 0;
  }
  /deep/ .van-hairline--top::after {
    border-top-width: 0;
  }
  /deep/ .zsy-logo-div2 {
    position: fixed;
    bottom: 0px;
    margin-bottom: 15px;
    padding-bottom: constant( safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
</style>
